import React from 'react';
import PremiumCollection from './PremiumCollection';
import FaqSection from './FaqSection';
import HeroSection from './HeroSection';
import Carousel from './Carousel';
import { Link } from 'react-router-dom';

function Landingpage() {
  return (
    <div className="  bg-gradient-to-b from-black via-[#2F2922] to-[#574C42]">
      {/* <HeroSection/> */}
      <Carousel/>
      {/* Hero Section

    {/* What Makes Us Different Section */}
<section className=" pt-12 md:pt-8 md:py-40 px-8 lg:px-28 xl:px-16 font-playfair mb-12">

  <h2 className="text-center text-3xl md:text-4xl font-bold text-white mb-12">
    What Makes Us Different
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-2  xl:grid-cols-4 gap-8">
    {/* Image 1 */}
    <div className="relative">
      <div className="border border-white">
        <img
          src="images/banner3.jpg"
          alt="Blind 1"
          className="w-full h-80 object-cover"
        />
      </div>
   
      <div className="absolute bottom-0 md:bottom-32 flex items-start justify-start p-4">
        <div className="text-left">
          <h1 className="text-white font-bold text-lg">Premium Fit</h1>
          <h2 className="text-zinc-300 text-sm">Perfect for every window size</h2>
        </div>
      </div>
    </div>

    {/* Image 2 */}
    <div className="relative md:mt-32">
      <div className="border border-white">
        <img
          src="images/aura3.webp"
          alt="Blind 2"
          className="w-full h-80 object-cover"
        />
      </div>
      <div className="absolute bottom-0 flex items-start justify-start p-4">
        <div className="text-left">
          <h1 className="text-white font-bold text-lg">Custom Fit</h1>
          <h2 className="text-zinc-300 text-sm">Perfect for every window size</h2>
        </div>
      </div>
    </div>

    {/* Image 3 */}
    <div className="relative md:mt-16">
      <div className="border border-white">
        <img
          src="images/banner7.jpg"
          alt="Blind 3"
          className="w-full h-80 object-cover"
        />
      </div>
      <div className="absolute inset-0 flex items-start justify-start p-4">
        <div className="text-left">
          <h1 className="text-white font-bold text-lg">Elegance Evening</h1>
          <h2 className="text-zinc-300 text-sm">Save energy with our innovative blinds</h2>
        </div>
      </div>
    </div>

    {/* Image 4 */}
    <div className="relative md:mt-32">
      <div className="border border-white">
        <img
          src="images/newbg2.webp"
          alt="Blind 4"
          className="w-full h-80 object-cover"
        />
      </div>

      <div className="absolute bottom-0  flex items-start justify-start p-4">
        <div className="text-left">
          <h1 className="text-white font-bold text-lg">Durable Materials</h1>
          <h2 className="text-zinc-300 text-sm">Built to last with premium quality</h2>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-gradient-to-b from-[#393838] via-[#2B5163] to-[#CBD2D3] py-16 font-playfair px-2 md:px-16">
 

  <div className="flex flex-col xl:flex-row  items-center gap-16">
    {/* Left Side: Description */}
    
    <div className="text-white flex-1">
    <h2 className="text-center text-4xl md:text-5xl font-bold text-white mb-12">
    Advanced Innovation
  </h2>
      <p className="text-2xl mb-6 text-center px-2 md:text-justify">
        Our commitment to innovation is reflected in the cutting-edge technology we incorporate into our products.
        From automated systems to energy-saving features, we continuously strive to enhance performance and user experience
        Smart Integration Seamlessly connect with your smart home devices for ultimate convenience Energy Efficiency 
        </p>

        <p className='text-2xl mb-6 text-center px-3 md:text-justify'>Advanced sensors optimize energy use, reducing costs while protecting the environment High Durability Crafted with the 
        highest quality materials for long-lasting performance Customizable Designs Tailored to fit your needs, offering flexibility in styles and functionality.
      </p>

      {/* Call to Action Button */}
      <div className="text-center mt-12">
       
        <Link to="/motarization">
        <button className="text-sm font-semibold md:text-md xl:text-xl border-2 bg-white border-[#b4b0b0] px-6 py-2 xl:py-2 md:px-8 w-40 md:w-40 xl:w-52 text-black">
        Learn More
        </button>
      </Link>
      </div>
    </div>

    {/* Right Side: Images/Video */}
    <div className="flex-1">
      <img
        src="images/motorimg3.png"
        alt="Advanced Innovation"
        className="md:w-[600px] md:h-[500px] rounded-lg shadow-lg"
      />
    </div>
  </div>
</section>


<PremiumCollection/>

<FaqSection/>

<section className="relative bg-cover bg-center py-24 " style={{  backgroundImage: "url('images/landing.png') " }}>
  <div className="absolute inset-0 bg-black bg-opacity-50"></div>
  <div className="relative z-10 container mx-auto text-center text-white px-6">
    <h2 className="text-4xl md:text-5xl font-bold mb-6 font-playfair">Elevate Your Space with Custom Blinds</h2>
    <p className="text-lg md:text-xl mb-8 font-playfair">
      Whether you're looking for elegance, functionality, or a touch of luxury, we've got you covered. 
      Get in touch today to find the perfect blinds for your home or office!
    </p>
    <a
      href="/contactus"
      className="inline-block  bg-[#ffffff] text-black font-semibold px-8 py-3  shadow-lg hover:bg-[#c3bdb5] transition duration-300"
    >
      Request Quote
    </a>
  </div>
</section>

    </div>
  );
}

export default Landingpage;

// import React from 'react';
// import PremiumCollection from './PremiumCollection';
// import FaqSection from './FaqSection';

// function Landingpage() {
//   return (
//     <div className="  bg-gradient-to-b from-black via-[#2F2922] to-[#574C42]">
//       {/* Hero Section */}
//       <div className="relative">
//   <video
//     autoPlay
//     loop
//     muted
//     playsInline
//     className="w-full h-screen object-cover z-10"
//   >
//     <source src="images/blindsvideo.mp4" type="video/mp4" />
//     Your browser does not support the video tag.
//   </video>

//   <div className="absolute top-1/3 md:top-10 right-0 md:right-8">
//     <ul className="flex flex-col gap-6">
//       <li>
//         <a href="#facebook" className="hover:underline">
//           <img src="images/fb.png" alt="Facebook" className="w-8 h-8" />
//         </a>
//       </li>
//       <li>
//         <a href="#youtube" className="hover:underline">
//           <img src="images/insta.png" alt="YouTube" className="w-8 h-8" />
//         </a>
//       </li>
//       <li>
//         <a href="#pinterest" className="hover:underline">
//           <img src="images/linkedin.png" alt="Pinterest" className="w-8 h-8" />
//         </a>
//       </li>
//       <li>
//         <a href="#houzz" className="hover:underline">
//           <img src="images/x.png" alt="Houzz" className="w-8 h-8" />
//         </a>
//       </li>
//       <li>
//         <a href="#instagram" className="hover:underline">
//           <img src="images/mail.png" alt="Instagram" className="w-10 h-8" />
//         </a>
//       </li>
//     </ul>
//   </div>

//   <div className="absolute top-[10%] md:top-[15%] md:left-10 flex flex-col xl:flex-row items-start text-4xl xl:text-6xl font-bold tracking-widest z-20 px-2">
//     <h2 className="font-Montserrat font-semibold text-5xl md:text-8xl lg:text-9xl xl:text-[170px] 2xl:text-[200px] bg-gradient-to-r from-[#ffffff] via-zinc-100 to-slate-200 text-transparent bg-clip-text">
//       ELEGANT
//     </h2>
//     <p className="text-sm md:text-base max-w-xs md:max-w-sm text-white mt-6">
//       Enhance your home's ambiance with our collection of elegant shades, designed for timeless beauty and effortless comfort.
//     </p>
//   </div>

//   <div className="flex flex-col sm:flex-row absolute top-1/3 md:top-[50%] left-1/2 gap-6 sm:gap-10 transform -translate-x-1/2 z-20">
//     <button className="text-sm md:text-xl border-2 bg-black font-bold border-white px-6 py-2 md:px-8 w-40 md:w-56 text-white">
//       EXPLORE
//     </button>
//     <button className="text-sm md:text-xl border-2 bg-black font-bold border-white px-6 py-2 md:px-8 w-40 md:w-56 text-white">
//       REACH OUT
//     </button>
//   </div>

//   <div className="absolute bottom-1/4 md:bottom-24 xl:bottom-32 right-10 xl:right-20 flex flex-col xl:flex-row items-start xl:items-center text-4xl xl:text-6xl font-bold tracking-widest z-20 space-y-4 xl:space-y-0 xl:space-x-4 px-2">
//     <p className="text-sm md:text-base text-white max-w-xs md:max-w-sm">
//       Transform your space with our premium, tailor-made elegant shades that offer both style and functionality.
//     </p>
//     <h2 className="font-Montserrat font-semibold text-5xl md:text-8xl lg:text-9xl xl:text-[160px] 2xl:text-[200px] bg-gradient-to-r from-[#ffffff] via-zinc-100 to-slate-200 text-transparent bg-clip-text">
//       SHADES
//     </h2>
//   </div>
// </div>

//     {/* What Makes Us Different Section */}
// <section className=" pt-12 md:py-40 px-8 md:px-16 font-playfair">
//   <h2 className="text-center text-3xl md:text-4xl font-bold text-white mb-12">
//     What Makes Us Different
//   </h2>
//   <div className="grid grid-cols-1 md:grid-cols-2  xl:grid-cols-4 gap-8">
//     {/* Image 1 */}
//     <div className="relative">
//       <div className="border-4 border-white">
//         <img
//           src="images/landing.png"
//           alt="Blind 1"
//           className="w-full h-80 object-cover"
//         />
//       </div>
//       <div className="absolute inset-0 flex items-start justify-start p-4">
//         <div className="text-left">
//           <h3 className="text-white font-bold text-lg">Premium Blinds</h3>
//           <p className="text-zinc-500 text-sm">Elegant designs for modern spaces</p>
//         </div>
//       </div>
//     </div>

//     {/* Image 2 */}
//     <div className="relative md:mt-32">
//       <div className="border-4 border-white">
//         <img
//           src="images/landing4.png"
//           alt="Blind 2"
//           className="w-full h-80 object-cover"
//         />
//       </div>
//       <div className="absolute bottom-0 flex items-start justify-start p-4">
//         <div className="text-left">
//           <h3 className="text-white font-bold text-lg">Custom Fit</h3>
//           <p className="text-zinc-500 text-sm">Perfect for every window size</p>
//         </div>
//       </div>
//     </div>

//     {/* Image 3 */}
//     <div className="relative md:mt-16">
//       <div className="border-4 border-white">
//         <img
//           src="images/landing2.png"
//           alt="Blind 3"
//           className="w-full h-80 object-cover"
//         />
//       </div>
//       <div className="absolute inset-0 flex items-start justify-start p-4">
//         <div className="text-left">
//           <h3 className="text-white font-bold text-lg">Energy Efficient</h3>
//           <p className="text-zinc-500 text-sm">Save energy with our innovative blinds</p>
//         </div>
//       </div>
//     </div>

//     {/* Image 4 */}
//     <div className="relative md:mt-32">
//       <div className="border-4 border-white">
//         <img
//           src="images/landing1.png"
//           alt="Blind 4"
//           className="w-full h-80 object-cover"
//         />
//       </div>
//       <div className="absolute bottom-0  flex items-start justify-start p-4">
//         <div className="text-left">
//           <h3 className="text-white font-bold text-lg">Durable Materials</h3>
//           <p className="text-zinc-500 text-sm">Built to last with premium quality</p>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>

// <section className="bg-gradient-to-b from-[#393838] via-[#2B5163] to-[#CBD2D3] py-16 font-playfair px-2 md:px-16">
 

//   <div className="flex flex-col xl:flex-row  items-center gap-16">
//     {/* Left Side: Description */}
    
//     <div className="text-white flex-1">
//     <h2 className="text-center text-3xl md:text-5xl font-bold text-white mb-12">
//     Advanced Innovation
//   </h2>
//       <p className="text-2xl mb-6 text-justify">
//         Our commitment to innovation is reflected in the cutting-edge technology we incorporate into our products.
//         From automated systems to energy-saving features, we continuously strive to enhance performance and user experience.
//       </p>

//       <ul className="text-lg text-gray-300 text-justify px-3">
//         <li>Smart Integration: Seamlessly connect with your smart home devices for ultimate convenience.</li>
//         <li>Energy Efficiency: Advanced sensors optimize energy use, reducing costs while protecting the environment.</li>
//         <li>High Durability: Crafted with the highest quality materials for long-lasting performance.</li>
//         <li>Customizable Designs: Tailored to fit your needs, offering flexibility in styles and functionality.</li>
//       </ul>

//       {/* Call to Action Button */}
//       <div className="text-center mt-12">
//         <a
//           href="/learn-more"
//           className="inline-block  px-4 md:px-8 py-3 text-black bg-[#ac9b82]  hover:bg-blue-700 transition-colors duration-300"
//         >
//           Learn About Our Innovations
//         </a>
//       </div>
//     </div>

//     {/* Right Side: Images/Video */}
//     <div className="flex-1">
//       <img
//         src="images/blind1.png"
//         alt="Advanced Innovation"
//         className="md:w-[600px] md:h-[600px] rounded-lg shadow-lg"
//       />
//     </div>
//   </div>
// </section>


// <PremiumCollection/>

// <FaqSection/>

// <section className="relative bg-cover bg-center py-24 font-playfair" style={{  backgroundImage: "url('images/landing.png') " }}>
//   <div className="absolute inset-0 bg-black bg-opacity-50"></div>
//   <div className="relative z-10 container mx-auto text-center text-white px-6">
//     <h2 className="text-4xl md:text-5xl font-bold mb-6">Elevate Your Space with Custom Blinds</h2>
//     <p className="text-lg md:text-xl mb-8">
//       Whether you're looking for elegance, functionality, or a touch of luxury,<br/> we've got you covered. 
//       Get in touch today to find the perfect blinds for your home or office!
//     </p>
//     <a
//       href="/contact"
//       className="inline-block bg-[#ac9b82] text-white font-semibold px-8 py-3  shadow-lg hover:bg-[#9e7f52] transition duration-300"
//     >
//       Request Your Free Quote
//     </a>
//   </div>
// </section>

//     </div>
//   );
// }

// export default Landingpage;


